var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
/**
 * A resable modal component
 *
 * @slot - The default slot for modal content
 * @slot opener - The opener button slot
 * @csspart backdrop - The modal backdrop
 * @csspart content - The modal content
 * @csspart opener - The default opener button
 */
let GrModal = class GrModal extends LitElement {
    constructor() {
        super();
        this.open = false;
        this.openerText = null;
        this._handleEscape = (e) => {
            if (e.key === "Escape" || e.key === "Esc") {
                this.close();
            }
        };
        this.addEventListener("click", (e) => {
            // Prevent clicks from bubbling up from the modal to the enclosing element
            e.stopPropagation();
            const target = e.target;
            if (target.dataset.closeModal !== undefined) {
                e.preventDefault();
                this.close();
            }
            if (target.dataset.openModal !== undefined) {
                e.preventDefault();
                this.show();
            }
        });
    }
    render() {
        return html `
      <div class="${classMap({ wrapper: true, open: this.open })}">
        <div part="backdrop" class="backdrop" @click="${this.close}"></div>
        <div part="content" class="content">
          <slot><p>Empty modal</p></slot>
        </div>
      </div>
      <slot name="opener">
        ${this.openerButton()}
      </slot>
    `;
    }
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    updated(changes) {
        if (changes.has("open")) {
            if (this.open) {
                document.body.style.overflow = 'hidden';
            }
            else {
                document.body.style.overflow = '';
            }
        }
    }
    connectedCallback() {
        super.connectedCallback();
        document.addEventListener("keyup", this._handleEscape);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener("keyup", this._handleEscape);
    }
    openerButton() {
        return this.openerText !== null
            ? html `<button class="opener" part="opener" @click="${this.show}">${this.openerText}</button>`
            : null;
    }
    show() {
        this.open = true;
    }
    close() {
        this.open = false;
    }
};
GrModal.styles = css `
    .wrapper {
      opacity: 0;
      position: absolute;
      z-index: 10;
      transition: opacity 0.25s ease-in;
    }
    .wrapper:not(.open) {
      visibility: hidden;
    }
    .wrapper.open {
      opacity: 1;
      visibility: visible;
    }
    .backdrop {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.5);
    }
    .content {
      position: fixed;
      top: 3em;
      bottom: 3em;
      right: 20%;
      left: 20%;
      padding: 2em 3em;
      background-color: white;
      overflow: auto;
    }
  `;
__decorate([
    property({ type: Boolean })
], GrModal.prototype, "open", void 0);
__decorate([
    property({ type: String })
], GrModal.prototype, "openerText", void 0);
GrModal = __decorate([
    customElement("gr-modal")
], GrModal);
export { GrModal };
//# sourceMappingURL=gr-modal.js.map